import React, { Component } from 'react'

import Searchbar from '../../utils/Searchbar'
import SearchProduct from '../../search/SearchProduct'

class ProductSearch extends Component {
    render() {
        return (
            <div>
                <Searchbar placeholder={"Search products"} component={SearchProduct} searchEndpoint={'search/product'} {...this.props} userType="admin" />
            </div>
        )
    }
}

export default ProductSearch



// WEBPACK FOOTER //
// ./src/components/admin/products/ProductSearch.js